import React from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { getLocalDateFromUTC } from "./form_utility";
import { ActionLogContainer } from "../../styles/general";

class ActionLogComponent extends React.Component<any, any> {
  public render() {
    const { mainForm, handleSubmit } = this.props;
    const formValues = mainForm.mainForm ? mainForm.mainForm.values : null;
    return (
      <div style={{ minHeight: "55vh" }}>
        <form onSubmit={handleSubmit}>
          <Grid
            style={{ padding: "30px 10px 0px 15px" }}
            container={true}
            spacing={2}
          >
            {formValues.userActionLogs.length ? (
              formValues.userActionLogs.map((value: any) => {
                return (
                  <ActionLogContainer>
                    {getLocalDateFromUTC(value.date)} - {value.action} by{" "}
                    {value.userName}
                  </ActionLogContainer>
                );
              })
            ) : (
              <div>Action Logs are not available for this case.</div>
            )}
          </Grid>
        </form>
      </div>
    );
  }
}

const ActionLogForm = reduxForm({
  form: "mainForm",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  // @ts-ignore
})(ActionLogComponent);

function mapStateToProps(state: any, ownProps: any) {
  return {
    mainForm: state.form,
    route: state.routing,
    attachmentData: state.detail.attachmentDataInventory,
    caseData: state.detail.caseData,
    allowEdit: state.detail.allowEdit,
    currentUser: state.home.currentUser,
    currentUsername: state.detail.currentUsername,
    isLockForEdit: state.detail.isLockForEdit,
  };
}

export default connect(mapStateToProps, null)(ActionLogForm);
